const Footer = ()=>{
    return (
        <section id="footer" className="footer-section">
        <div className="contact-info">
            <h3>Want to work together?</h3>
            <address>
                LinkedIn : <a href="https://www.linkedin.com/in/nathaniel-boucher-a6051a224/">www.linkedin.com</a> <br />
                Github : <a href="https://github.com/natejboucher">www.GitHub.com/NateJBoucher</a> <br />
                StackOverflow : <a href="https://stackoverflow.com/users/17284889/nathaniel-boucher">www.StackOverflow.com</a>
            </address>
        </div>
    </section>
    )
}

export default Footer;